import Vue from 'vue'
import Vuex from 'vuex'
import { load } from './storage'

import tryout from './modules/tryout'

Vue.use(Vuex)

const state = load('root') || {}

export default new Vuex.Store({
  state,
  mutations: {},
  actions: {},
  modules: {
    tryout,
  },
})
